/**
 * Web stub for `@/libs/revopush`.
 * RevoPush is native-only; importing the package on web crashes inside `AlertAdapter.js`
 * because it destructures `Alert` from React Native, which doesn't exist in `react-native-web`.
 * This file shadows the native `index.ts` when Metro bundles for the web platform.
 */

export type DownloadProgress = {
  totalBytes: number;
  receivedBytes: number;
};

export type RemotePackage = {
  appVersion: string;
  deploymentKey: string;
  description: string;
  failedInstall: boolean;
  isMandatory: boolean;
  label: string;
  packageHash: string;
  packageSize: number;
  downloadUrl: string;
};

/** Mirrors the numeric values of `CodePush.SyncStatus` so callers can compare against native enum members. */
export const SyncStatus = {
  UP_TO_DATE: 0,
  UPDATE_INSTALLED: 1,
  UPDATE_IGNORED: 2,
  UNKNOWN_ERROR: 3,
  SYNC_IN_PROGRESS: 4,
  CHECKING_FOR_UPDATE: 5,
  AWAITING_USER_ACTION: 6,
  DOWNLOADING_PACKAGE: 7,
  INSTALLING_UPDATE: 8,
} as const;
export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];

export type RevoPushSyncResult =
  | { status: 'up_to_date' }
  | { status: 'update_installed'; label?: string; isMandatory: boolean }
  | { status: 'unsupported_platform' }
  | { status: 'error'; error: unknown };

export type RevoPushSyncOptions = {
  onStatusChange?: (status: SyncStatus) => void;
  onDownloadProgress?: (progress: DownloadProgress) => void;
  immediateInstall?: boolean;
  deferMandatoryRestart?: boolean;
};

export async function syncRevoPushUpdate(
  _options: RevoPushSyncOptions = {},
): Promise<RevoPushSyncResult> {
  return { status: 'unsupported_platform' };
}

export async function checkRevoPushUpdate(): Promise<RemotePackage | null> {
  return null;
}

export async function notifyRevoPushAppReady(): Promise<void> {
  // no-op on web
}

export function restartRevoPushApp(_onlyIfUpdateIsPending = false): void {
  // no-op on web
}

export const allowRestart = () => {
  // no-op on web
};
